import { getGuid } from 'owa-guid';
import { createTodo, Todo } from 'owa-todo-types';
import { getTodoCache } from '../todoCache';
import handleCreateTodos from './handleCreateTodos';
import type { CustomData } from 'owa-analytics-actions';

export interface CreateTodosResponse {
    items: Todo[];
    success: boolean;
}

export async function createTodos(
    partialTodos: Partial<Todo>[],
    folderId: string,
    telemetryData: CustomData
): Promise<CreateTodosResponse> {
    if (!partialTodos) {
        return {
            items: [],
            success: true,
        };
    }

    const fullTodos: Todo[] = partialTodos.map((todo, index) =>
        createTodo({
            Id: getGuid(),
            ParentFolderId: folderId,
            ...todo,
        })
    );
    // add local lies
    fullTodos.forEach(getTodoCache().addItem);

    const localLieIds = fullTodos.map(todo => todo.Id);

    // Kick off the add todo actions
    const todos = await handleCreateTodos(fullTodos, folderId, telemetryData);
    const todosSuccessfullyCreated = todos.filter(todo => todo !== null) as Todo[];

    // remove local lies
    localLieIds.forEach(getTodoCache().deleteItem);
    todosSuccessfullyCreated.forEach(getTodoCache().addItem);

    return {
        items: todosSuccessfullyCreated,
        success: todosSuccessfullyCreated.length === todos.length,
    };
}
